/**
 * Operator details shown in the documents. Replace with your legal entity before launch.
 */
export const LEGAL = {
  company: 'Bannermatic',
  email: 'support@bannermatic.app',
  /** Date of the current version (ISO). */
  updated: '2026-10-04',
};

export interface LegalDoc {
  title: string;
  intro: string;
  sections: Array<{ h: string; p: string[] }>;
}

export type LegalKind = 'privacy' | 'terms';

/** One language's documents (pl.ts, ro.ts, es.ts). */
export type LegalSet = Record<LegalKind, LegalDoc>;
